// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container2 {
    background-color: #F1F1F1;
    border: solid 1px #d4d4d4;
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 50px;
}

.title {
    font-family: "GothamBold", Arial, sans-serif;
}

.content {
    font-family: "GothamNarrowBook", Arial, sans-serif;
}

mat-spinner {
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/app/doa/user-information/user-information.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC","sourcesContent":[".container2 {\n    background-color: #F1F1F1;\n    border: solid 1px #d4d4d4;\n    border-radius: 5px;\n    margin-bottom: 15px;\n    padding: 50px;\n}\n\n.title {\n    font-family: \"GothamBold\", Arial, sans-serif;\n}\n\n.content {\n    font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\nmat-spinner {\n    margin: auto;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
